// Setup moment.js locale bundle-wide
import moment from 'moment';
import 'moment/locale/current';
moment.locale(__LOCALE__);
